import { Mui } from "@osu/react-ui";

const HighlightBox = Mui.styled(Mui.Typography)(({ theme }) => {
  const bg = Mui.alpha(theme.palette.primary.main, 0.08);
  const color = theme.palette.secondary.main
  return {
    marginTop: theme.spacing(2),
    padding:theme.spacing(2),
    backgroundColor: bg,
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(3),
    color
  };
});

export default HighlightBox